import React, { useState, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useLocation } from 'react-router-dom';
import FooterOpcoes from '../components/FooterOpcoes';
import CarrinhoIcon from '../components/CarrinhoIcon';
import styles from "./PedidoClique.module.css";

function PedidoClique() {
    const location = useLocation();
    const { id_item, id_estabelecimento, src, label_title, p_descricao, p_preco } = location.state || {};

    const [observacao, setObservacao] = useState("");
    const [quantidade, setQuantidade] = useState(1);

    const precoNumerico = typeof p_preco === 'string'
        ? parseFloat(p_preco.replace('R$', '').replace(',', '.').trim())
        : parseFloat(p_preco) || 0;

    const precoTotal = (precoNumerico * quantidade).toFixed(2).replace('.', ',');

    // Salva o estabelecimento_id no localStorage quando o componente é montado
    useEffect(() => {
        if (id_estabelecimento) {
            localStorage.setItem('estabelecimento_id', id_estabelecimento);
            console.log('✅ [PEDIDO CLIQUE] estabelecimento_id salvo no localStorage:', id_estabelecimento);
            // Disparar evento para conectar SSE
            window.dispatchEvent(new CustomEvent('estabelecimentoChanged', {
                detail: { estabelecimentoId: id_estabelecimento }
            }));
        }
    }, [id_estabelecimento]);

    const adicionarAoCarrinho = (item) => {
        let carrinho = JSON.parse(localStorage.getItem('carrinho')) || [];
        carrinho.push(item);
        localStorage.setItem('carrinho', JSON.stringify(carrinho));

        // Salvar o estabelecimento_id no localStorage
        if (item.id_estabelecimento) {
            localStorage.setItem('estabelecimento_id', item.id_estabelecimento);
            console.log('✅ [CARRINHO] estabelecimento_id salvo no localStorage:', item.id_estabelecimento);
            // Disparar evento para conectar SSE
            window.dispatchEvent(new CustomEvent('estabelecimentoChanged', {
                detail: { estabelecimentoId: item.id_estabelecimento }
            }));
        }

        // 🔔 dispara evento para atualizar ícone
        window.dispatchEvent(new Event("carrinhoAtualizado"));

        alert(`${item.label_title} foi adicionado ao carrinho!`);
    };


    const addCart = () => {

        const item = {
            uuid: uuidv4(),
            id_item,
            id_estabelecimento,
            src,
            label_title,
            p_descricao,
            preco: precoNumerico,
            quantidade,
            observacao
        };

        adicionarAoCarrinho(item);
        console.log("Item adicionado ao carrinho", item);
    };

    return (
        <div className={styles.secaopedidoclique}>
          {/*  <header className={styles.headerPedidoClique}>
            </header>*/}
                <CarrinhoIcon />

            <div className={styles.imagemContainer}>
                <img src={src} alt={label_title} />
            </div>

            <div className={styles.detalhesContainer}>
                <h1 className={styles.titulo}>{label_title}</h1>
                <p className={styles.descricao}>{p_descricao}</p>

                <div className={styles.infoAdicional}>
                    <span className={styles.preco}> {p_preco}</span>
        
                </div>

                <textarea
                    className={styles.textarea}
                    name="comentario"
                    placeholder="Gostaria de adicionar ou retirar algo? Ex: Cebola, tomate..."
                    value={observacao}
                    onChange={(e) => setObservacao(e.target.value)}
                ></textarea>

                <div className={styles.rodape}>
                    <div className={styles.controleQuantidade}>
                        <button onClick={() => setQuantidade(q => Math.max(1, q - 1))}>−</button>
                        <span>{quantidade}</span>
                        <button onClick={() => setQuantidade(q => q + 1)}>+</button>
                    </div>
                    <button className={styles.btnAdicionar} onClick={addCart}>
                        Adicionar R$ {precoTotal}
                    </button>
                </div>
            </div>

            <FooterOpcoes typeView={"cliente"} />
        </div>
    );
}

export default PedidoClique;
